module.exports = __webpack_public_path__ + "img/cjwt-icon.aa9dacd8.png";